import React from 'react'
import { useForm, Link } from '@inertiajs/react'
import { TextField, Button, Typography, Stack } from '@mui/material'
import AuthLayout from '@/components/layouts/AuthLayout'
import { SPACING } from '@/theme'

interface Props {
  resetPasswordToken: string
  minimumPasswordLength?: number
}

export default function ResetPassword({ resetPasswordToken, minimumPasswordLength = 6 }: Props) {
  const { data, setData, put, processing, errors } = useForm({
    reset_password_token: resetPasswordToken,
    password: '',
    password_confirmation: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put('/users/password')
  }

  return (
    <AuthLayout title="Set new password">
      <Stack component="form" onSubmit={handleSubmit} spacing={SPACING.gap.md}>
        <TextField
          label="New password"
          type="password"
          fullWidth
          value={data.password}
          onChange={(e) => setData('password', e.target.value)}
          error={!!errors.password}
          helperText={errors.password || `${minimumPasswordLength} characters minimum`}
          autoFocus
          autoComplete="new-password"
        />
        <TextField
          label="Confirm new password"
          type="password"
          fullWidth
          value={data.password_confirmation}
          onChange={(e) => setData('password_confirmation', e.target.value)}
          error={!!errors.password_confirmation}
          helperText={errors.password_confirmation}
          autoComplete="new-password"
        />
        <Button type="submit" variant="contained" fullWidth size="large" disabled={processing}>
          Reset password
        </Button>
        <Typography variant="body2" align="center">
          Remember your password? <Link href="/users/sign_in">Sign in</Link>
        </Typography>
      </Stack>
    </AuthLayout>
  )
}
